// extracted by mini-css-extract-plugin
export default {"imageWrapper":"VD-z","hovered":"WD-z","hoverImage":"XD-z","mainImage":"YD-z","imageNoBackground":"ZD-z","fullSizeImage":"_D-z"};